/****************************************************************************
 * COPYRIGHT (c) 2024 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/

import {
    FETCH_CLUSTER_DETAILS_REQUEST,
    FETCH_CLUSTER_DETAILS_SUCCESS,
    FETCH_CLUSTER_DETAILS_FAILURE,
  } from "./ClusterCompatibilityTypes";

  const initialState = {
    loading: false,
    clusterDetails: {},
    error: "",
  };
  
  const clusterDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_CLUSTER_DETAILS_REQUEST:
        return {
          ...state,
          loading: true,
        };
  
      case FETCH_CLUSTER_DETAILS_SUCCESS:
        return {
          loading: false,
          clusterDetails: action.payload,
          error: "",
        };
      case FETCH_CLUSTER_DETAILS_FAILURE:
        return {
          loading: false,
          clusterDetails: {},
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default clusterDetailsReducer;
  